import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRef } from 'vue'
import CompletedActionCard from './CompletedActionCard.vue'
import CompletedAutoRtConsent from './CompletedAutoRtConsent.vue'
import AtenaLabelSuggest from '@/components/format-edit/AtenaLabelSuggest.vue'
import SuggestLinkCard from '@/components/format-edit/SuggestLinkCard.vue'
import completedDigramSuggestFormats from '@/utils/format-edit/completedDigramSuggestFormats.json'
import { useCompletedOutput } from '@/composables/format-edit/useCompletedOutput'
import { resolveCompletedDocumentLabel } from '@/utils/format-edit/completedDocumentLabel'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedOutputPanel',
  props: {
    formatId: { default: '' },
    isSendYagiEmailEnabled: { type: Boolean, default: true },
    mailPdfEnabled: { type: Boolean, default: true },
    downloadPdfEnabled: { type: Boolean, default: true },
    eprintEnabled: { type: Boolean, default: true }
  },
  emits: ["update:isSendYagiEmailEnabled"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isSendYagiEmailEnabled', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { formatId: string, isSendYagiEmailEnabled: boolean, mailPdfEnabled: boolean, downloadPdfEnabled: boolean, eprintEnabled: boolean };

/**
 * 完了画面の出力パネル（旧 DownloadItem.vue の置き換え）。
 * GTM のトリガーが見ている id（completed-buttons / pdf-email / pdf-email-none / combie /
 * quickemail / pdf-download / 各ボタン id）は旧実装から変えていない。
 */




const eprintCtaEl = ref<HTMLElement | null>(null)

const {
  isAuthenticated,
  isEmailVerified,
  isOnline,
  isPdfDownloadButtonVisible,
  isQuickEmailVisible,
  quickEmailLabel,
  localIsSendYagiEmailEnabled,
  pdfMailBtnId,
  pdfDownloadBtnId,
  autoRtInfo,
  hasAutoRtPartnerTerms,
  autoRtPartnerTermsHtml,
  isAgree,
  handleEventWithLoginCheck,
  handleYagiEmailClick,
  requestEmailVerification,
  observeEprintCtaImpression,
  onRtAgreeChange
} = useCompletedOutput({
  formatId: toRef(props, 'formatId'),
  isSendYagiEmailEnabled: toRef(props, 'isSendYagiEmailEnabled'),
  onSendYagiEmail: () => emit('update:isSendYagiEmailEnabled', false)
})

observeEprintCtaImpression(eprintCtaEl)

const documentLabel = computed(() =>
  resolveCompletedDocumentLabel(props.formatId)
)

/** 宛名は用紙が違うので、コンビニ印刷の絵も宛名用（3 社）にする */
const eprintImageSrc = computed(() =>
  props.formatId === 'atena'
    ? '/static/renew2_img/atena_print_3stores.png'
    : '/static/renew2_img/print_20231024.png'
)

const isDigramSuggestVisible = computed(() =>
  completedDigramSuggestFormats.formatIds.includes(props.formatId)
)

const isAutoRtConsentVisible = computed(
  () => isAuthenticated.value && !!autoRtInfo.value.clientId
)

const mailAction = computed(() => {
  if (isEmailVerified.value) {
    return {
      title: 'PDFをメールで送る',
      note: '自分のメールアドレスにPDFデータを送信'
    }
  }
  if (isAuthenticated.value) {
    return {
      title: '確認メールを送る',
      note: 'メールアドレスの確認後にメールで送信できます'
    }
  }
  return {
    title: 'PDFをメールで送る',
    note: '自分のメールアドレスにPDFデータを送信'
  }
})

function onMailClick() {
  if (isEmailVerified.value) {
    handleEventWithLoginCheck('mail-PDF')
    return
  }
  if (isAuthenticated.value) {
    requestEmailVerification()
    return
  }
  handleEventWithLoginCheck('send-email-verification')
}

return { __sfc: true,props, emit, eprintCtaEl, isAuthenticated, isEmailVerified, isOnline, isPdfDownloadButtonVisible, isQuickEmailVisible, quickEmailLabel, localIsSendYagiEmailEnabled, pdfMailBtnId, pdfDownloadBtnId, autoRtInfo, hasAutoRtPartnerTerms, autoRtPartnerTermsHtml, isAgree, handleEventWithLoginCheck, handleYagiEmailClick, requestEmailVerification, observeEprintCtaImpression, onRtAgreeChange, documentLabel, eprintImageSrc, isDigramSuggestVisible, isAutoRtConsentVisible, mailAction, onMailClick, CompletedActionCard, CompletedAutoRtConsent, AtenaLabelSuggest, SuggestLinkCard }
}

})